import React from 'react';
import { Case } from '../../services/buildfire/rdb/cases';
import {
  getPaymentStatusDescription,
  usePaymentInfo,
} from './caseInfo/PaymentInfo';
import { formatCurrencyCents } from '../../util/currency';
import { CreditCardSummary } from '../submitCase/components/paymentList/PaymentMethodListItem';
import InfoSection, { LineItem } from './caseInfo/InfoSection';
import { CaseType } from '../../stateMachines/submitCase/caseType';

interface PaymentInfoProps {
  case: Case;
}

const PaymentInfo: React.FC<PaymentInfoProps> = ({ case: c }) => {
  const isInvoiced = !!c.invoiceAccount;

  const { invoice, isLoading, paymentMethods } = usePaymentInfo(c);
  const totalCents =
    invoice?.products?.map((p) => p.amount)?.reduce((a, b) => a + b, 0) || 0;
  const total = formatCurrencyCents(totalCents);
  const selectedPaymentMethod = invoice
    ? paymentMethods.find((pm) => pm.id === invoice.paymentMethodId)
    : null;

  const cardInfo = selectedPaymentMethod?.card ? (
    <CreditCardSummary
      brand={selectedPaymentMethod.card.brand}
      lastFour={selectedPaymentMethod.card.last4}
    />
  ) : (
    'Error'
  );
  return (
    <InfoSection title="Payment Info">
      {!isInvoiced && (
        <LineItem
          name="Payment method"
          description={isLoading ? 'Loading...' : cardInfo}
        />
      )}
      <LineItem name="Status" description={getPaymentStatusDescription(c)} />
      <LineItem
        name="Case type"
        description={c.priority ? 'Priority' : 'Standard'}
      />
      <LineItem name="Total" description={total} />
    </InfoSection>
  );
};

export default PaymentInfo;
